function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_primitive(input, hint) {
    if (_type_of(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_type_of(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _to_property_key(arg) {
    var key = _to_primitive(arg, "string");
    return _type_of(key) === "symbol" ? key : String(key);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Spinner } from '@fluentui/react';
// #region "Integrated imports, don't add @shared"
import { getGalleryPageTitle } from '@appsource/utils/consultingServicesUtils';
import { getAppGalleryPageTitle, getFeaturedAppsTitle } from '@shared/utils/localization';
import CuratedGallery from '@shared/containers/curatedGallery';
import { FilterPane } from '@appsource/components/filterPane';
import { getFilterLink, shouldShowCuratedDataForActiveFilters, getPopularItems, getFeaturedItemsByFilter, isFilterChosen } from '@shared/utils/filterHelpers';
import { Constants } from '@shared/utils/constants';
import { DataMap } from '@shared/utils/dataMapping';
import { urlPush, routes } from '@shared/routerHistory';
import { removeDuplicateAddIns } from '@shared/utils/search';
import { NpsModule } from '@shared/utils/npsUtils';
import { addClassToElement, removeClassFromElements } from '@shared/utils/appUtils';
import CommonTile from '@shared/components/commonTile';
import AppsbannerImg from '@shared/images/banners/Appsbanner.png';
import CloudsIndustrybannerImg from '@shared/images/banners/CloudsIndustrybanner.png';
import ConsultingServicesImage from '@shared/images/banners/ConsultingServices.png';
import * as embedHostUtils from '@src/embed/embedHostUtils';
import PureSpzaComponent from './pureSpzaComponent';
import AppSourceFilteredGallery from '@appsource/components/filteredGallery';
import GalleryHeader from './galleryHeader';
import Ribbon from './ribbon';
import AppPromotionPane from './appPromotionPane';
import { InternalLink } from './internalLink';
import { Banner } from './banner';
import { PopularApps } from './popularApps';
import GalleryContent from './GalleryContent';
import { FilteredGalleryHeader } from '@shared/components/FilteredGalleryHeader';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
import { RecommendationsRibbon } from '@appsource/components/RecommendationsRibbonWrapper';
import { getPromotionBanner } from '@shared/utils/promotionBannerUtils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const classNames = require('classnames-minimal');
var ShowPopular = /*#__PURE__*/ function(ShowPopular) {
    ShowPopular["Always"] = "Always";
    ShowPopular["Never"] = "Never";
    ShowPopular["MainOnly"] = "MainOnly";
    ShowPopular["FilteredOnly"] = "FilteredOnly";
    return ShowPopular;
}(ShowPopular || {});
export class Gallery extends PureSpzaComponent {
    filterLinkCallback(filter, query) {
        return getFilterLink(this.context, filter, this.props.entityType, this.props.embedHost, false, !this.props.isAppSource, query);
    }
    getCurrentEntityData() {
        return this.getEntityData()[this.props.entityType];
    }
    getOthersEntitiesData() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _this_getEntityData = this.getEntityData(), _this_props_entityType = this.props.entityType, { [_this_props_entityType]: currentEntity } = _this_getEntityData, othersEntities = _object_without_properties(_this_getEntityData, [
            _this_props_entityType
        ].map(_to_property_key));
        return othersEntities;
    }
    getEntityData() {
        const entitiyes = {
            [Constants.EntityType.App]: _object_spread_props(_object_spread({}, this.props.entityData[Constants.EntityType.App]), {
                showPopoular: "Always",
                showRibbon: true,
                bannerData: {
                    title: this.context.loc('Banner_Apps_Title', 'Find the right app, right now'),
                    imgURL: AppsbannerImg,
                    description: this.context.loc('Banner_Apps_Description', 'Solve challenges with apps tailored for a wide range of industries and business needs—and begin propelling innovation and productivity today.')
                },
                galleryTitle: {
                    title: this.context.loc('GalleryTitle_Apps', 'Apps'),
                    mainTitle: this.context.loc('GalleryTitle_MainTitle_Default_Apps', 'Browse apps'),
                    subTitle: this.context.loc('GalleryTitle_SubTitle_Default_Apps', 'Filter and sort offers to refine the results.'),
                    linkHref: this.isFullscreenEmbedded() ? '' : this.context.buildHref(routes.marketplace, null, {
                        page: '1'
                    })
                }
            }),
            [Constants.EntityType.Service]: _object_spread_props(_object_spread({}, this.props.entityData[Constants.EntityType.Service]), {
                showPopoular: "Always",
                showRibbon: false,
                bannerData: {
                    title: this.context.loc('Banner_Services_Title', 'Find consulting services'),
                    imgURL: ConsultingServicesImage,
                    description: this.context.loc('Banner_Services_Description', 'Connect with experts who can help you digitally transform your organization.')
                },
                galleryTitle: {
                    title: this.context.loc('GalleryTitle_CS', 'Consulting services'),
                    mainTitle: this.context.loc('GalleryTitle_MainTitle_Default_CS', 'Browse consulting services'),
                    subTitle: this.context.loc('GalleryTitle_SubTitle_Default_CS', 'Refine offers by selecting filters and sorting options.'),
                    linkHref: this.context.buildHref(routes.marketplaceServices, null, {
                        page: '1'
                    })
                }
            }),
            [Constants.EntityType.CloudsIndustry]: _object_spread_props(_object_spread({}, this.props.entityData[Constants.EntityType.CloudsIndustry]), {
                showPopoular: "MainOnly",
                showRibbon: true,
                bannerData: {
                    title: this.context.loc('Banner_CloudsIndustry_Title', 'Microsoft Industry Clouds'),
                    imgURL: CloudsIndustrybannerImg,
                    description: this.context.loc('Banner_CloudsIndustry_Description', 'Microsoft Industry Clouds connect robust industry-specific capabilities across Azure, Power Platform, Microsoft 365 & Teams, Dynamics 365, and Security, underpinned by our common data model.  Helping businesses be more agile, make intelligent decisions, and provide rich customer, patient, and employee experiences.'),
                    links: [
                        {
                            text: this.context.loc('AppSource_banner_explore', 'Explore Microsoft Industry Clouds'),
                            params: [
                                'Microsoft Industry Clouds'
                            ],
                            url: 'https://www.microsoft.com/industry'
                        }
                    ]
                },
                galleryTitle: {
                    title: this.context.loc('GalleryTitle_CloudsIndustry', 'Industry Clouds'),
                    mainTitle: this.context.loc('GalleryTitle_MainTitle_Default_CloudsIndustry', 'Browse Industry Clouds'),
                    subTitle: this.context.loc('GalleryTitle_SubTitle_Default_CloudsIndustry', 'Filter and sort apps to refine the results.'),
                    linkHref: this.context.buildHref(routes.marketplaceCloudsIndustry, null, {
                        page: '1'
                    })
                }
            })
        };
        return entitiyes;
    }
    isSearchMode(entityType, entityData) {
        if (!entityType) {
            return undefined;
        }
        const searchQuery = entityData[`${entityType}`].subsetSearchQuery;
        return !!searchQuery && searchQuery.length > 0;
    }
    shouldShowCuratedView(entityType, entityData, query) {
        return entityType && !this.isSearchMode(entityType, entityData) && !query[Constants.QueryStrings.showAllApps] && shouldShowCuratedDataForActiveFilters(entityData[`${entityType}`].activeFilters) && !this.props.showPrivateApps && (!this.props.isEmbedded || embedHostUtils.shouldShowCuratedData(this.props.embedHost)) && (entityType !== Constants.EntityType.Service || this.shouldShowCuratededViewServices());
    }
    shouldShowCuratededViewServices() {
        var _this_getCurrentEntityData, _this_props_countryCode, _this_props_regionCode;
        if ((_this_getCurrentEntityData = this.getCurrentEntityData()) === null || _this_getCurrentEntityData === void 0 ? void 0 : _this_getCurrentEntityData.activeFilters.filter((activeFilter)=>activeFilter.BackendKey === DataMap.products.Office365.BackendKey).length) {
            return false;
        }
        if (((_this_props_countryCode = this.props.countryCode) === null || _this_props_countryCode === void 0 ? void 0 : _this_props_countryCode.toLowerCase()) !== Constants.usCountryCode) {
            return false;
        }
        if (((_this_props_regionCode = this.props.regionCode) === null || _this_props_regionCode === void 0 ? void 0 : _this_props_regionCode.toLowerCase()) !== Constants.allStatesCode) {
            return false;
        }
        return true;
    }
    startUp() {
        // accessibility
        switch(this.props.entityType){
            case Constants.EntityType.Service:
                document.getElementsByTagName('title')[0].innerHTML = this.context.loc(getGalleryPageTitle());
                removeClassFromElements('spza-accessibility-selected');
                // the bold on the UHF wont work till the new UHF header for services is added, thus highlighting the services
                addClassToElement(Constants.SearchBy.Id, 'uhf_servicesGalleryLink', 'spza-accessibility-selected');
                break;
            default:
                document.getElementsByTagName('title')[0].innerHTML = getAppGalleryPageTitle(this.context);
                removeClassFromElements('spza-accessibility-selected');
                addClassToElement(Constants.SearchBy.Id, 'uhf_galleryLink', 'spza-accessibility-selected');
                break;
        }
    }
    isAppliedFiltersEmpty() {
        var _this_getCurrentEntityData, _this_getCurrentEntityData1;
        return !((_this_getCurrentEntityData = this.getCurrentEntityData()) === null || _this_getCurrentEntityData === void 0 ? void 0 : _this_getCurrentEntityData.activeFilters.length) && !((_this_getCurrentEntityData1 = this.getCurrentEntityData()) === null || _this_getCurrentEntityData1 === void 0 ? void 0 : _this_getCurrentEntityData1.subsetSearchQuery);
    }
    manageShouldDisplayNumricValues() {
        if (this.isAppliedFiltersEmpty()) {
            this.setState({
                shouldDisplayNumricValues: false
            });
        } else if (!this.props.requestFilteredLoading) {
            this.setState({
                shouldDisplayNumricValues: true
            });
        }
    }
    componentDidMount() {
        // step 4: determine whether gallery view should show curated view, on the very first render
        const shouldShowCuratedView = this.shouldShowCuratedView(this.props.entityType, this.props.entityData, this.props.query);
        this.props.updateCurrentGalleryViewIsCurated(shouldShowCuratedView);
        NpsModule.checkForNPS();
        this.startUp();
    }
    componentDidUpdate() {
        this.startUp();
        this.manageShouldDisplayNumricValues();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // get shouldShowCuratedView consists of current props
        const shouldShowCuratedView = this.shouldShowCuratedView(this.props.entityType, this.props.entityData, this.props.query);
        // get shouldShowCuratedView consists of next props
        const nextShouldShowCuratedView = this.shouldShowCuratedView(nextProps.entityType, nextProps.entityData, nextProps.query);
        // update only if shouldShowCuratedView changes
        // without this check, it will in an infinite loop of re-rendering
        if (shouldShowCuratedView !== nextShouldShowCuratedView) {
            this.props.updateCurrentGalleryViewIsCurated(nextShouldShowCuratedView);
        }
    }
    getGalleryMainTitle() {
        if (this.getCurrentEntityData().subsetSearchQuery) {
            return this.context.locParams('GalleryTitle_MainTitle_Search', [
                this.getCurrentEntityData().subsetSearchQuery
            ], 'Search results for “{0}”');
        }
        const activeFiltersWithoutReference = this.getActiveFiltersWithoutReference();
        if (activeFiltersWithoutReference.length >= 1) {
            const firstFilterName = this.context.loc(activeFiltersWithoutReference[0].LocKey, activeFiltersWithoutReference[0].Title);
            return activeFiltersWithoutReference.length === 1 ? this.context.locParams('GalleryTitle_MainTitle_OneFilter', [
                this.getCurrentEntityData().galleryTitle.title,
                firstFilterName
            ], '{0} results for {1}') : this.context.locParams('GalleryTitle_MainTitle_MultipleFilter', [
                this.getCurrentEntityData().galleryTitle.title
            ], '{0} results');
        }
        return this.getCurrentEntityData().galleryTitle.mainTitle;
    }
    getGallerySubTitle() {
        const curEntityData = this.getCurrentEntityData();
        const curEntityCount = curEntityData.count;
        const { shouldDisplayNumricValues } = this.state;
        if (curEntityCount <= 0) {
            return this.context.locParams('GalleryTitle_No_Results', [
                (curEntityCount === null || curEntityCount === void 0 ? void 0 : curEntityCount.toString()) || '',
                curEntityData.galleryTitle.title.toLocaleLowerCase()
            ], 'Showing 0 results.');
        }
        if ((this.getActiveFiltersWithoutReference().length || curEntityData.subsetSearchQuery) && curEntityCount) {
            return this.context.locParams('GalleryTitle_Results', [
                shouldDisplayNumricValues ? curEntityCount.toString() : '',
                curEntityData.galleryTitle.title.toLocaleLowerCase()
            ], 'Showing {0} results in {1}.');
        }
        return curEntityData.galleryTitle.subTitle;
    }
    getActiveFiltersWithoutReference() {
        return this.getCurrentEntityData().activeFilters.filter((f)=>!f.IsReference);
    }
    renderOthersGalleriesLinks() {
        if (!this.getActiveFiltersWithoutReference().length) {
            return null;
        }
        const { shouldDisplayNumricValues } = this.state;
        const entitiesData = this.getOthersEntitiesData();
        const results = [];
        Object.keys(entitiesData).filter((entityType)=>entitiesData[`${entityType}`].count).forEach((entityType, index, entities)=>{
            const entityData = entitiesData[`${entityType}`];
            const href = entityData.galleryTitle.linkHref;
            const galleryTitle = entityData.galleryTitle.title.toLocaleLowerCase();
            const galleryResultsCount = entityData.count;
            const telemetryPayload = {
                relatedGallery: galleryTitle,
                relatedGalleryResultsCount: galleryResultsCount,
                relatedGalleryTargetUrl: href
            };
            if (index === 0) {
                results.push(/*#__PURE__*/ _jsxs("span", {
                    children: [
                        " ",
                        this.context.loc('GalleryTitle_Link_Pre', 'View'),
                        " "
                    ]
                }, `span-${href}`));
            } else {
                results.push(/*#__PURE__*/ _jsxs("span", {
                    children: [
                        " ",
                        this.context.loc('GalleryTitle_Link_Seperator', 'or'),
                        " "
                    ]
                }, `span-${href}`));
            }
            const numResultsText = shouldDisplayNumricValues ? (galleryResultsCount === null || galleryResultsCount === void 0 ? void 0 : galleryResultsCount.toString()) || '' : '';
            results.push(/*#__PURE__*/ _jsx(InternalLink, {
                href: href,
                className: "galleryTitleLink",
                accEnabled: true,
                "data-bi-id": 'gallery Title link',
                "data-bi-area": `entity: ${this.props.entityType}`,
                onClick: ()=>{
                    urlPush(entityData.galleryTitle.linkHref, true);
                },
                telemetryDetails: JSON.stringify(telemetryPayload),
                children: this.context.locParams('GalleryTitle_Link', [
                    numResultsText,
                    galleryTitle
                ], `${numResultsText} related results in ${galleryTitle}`)
            }, `internal-link-${href}`));
            if (index === entities.length - 1) {
                results.push(/*#__PURE__*/ _jsx("span", {
                    children: "."
                }, "dot"));
            }
        });
        return results;
    }
    isShowPopularItems() {
        const activeFilters = this.getActiveFiltersWithoutReference();
        const showPopular = this.getCurrentEntityData().showPopoular;
        if (showPopular === "Never" || showPopular === "MainOnly" && (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) !== 0 || showPopular === "FilteredOnly" && (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) !== 1) {
            return false;
        }
        if (this.isSearchMode(this.props.entityType, this.props.entityData)) {
            return false;
        }
        if (!this.props.isAppSource) {
            return false;
        }
        if (this.props.isEmbedded) {
            return false;
        }
        if ((activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 1) {
            return false;
        }
        if (activeFilters.length === 1 && [
            Constants.FilterQuery.product,
            Constants.FilterQuery.category,
            Constants.FilterQuery.industry
        ].indexOf(activeFilters[0].UrlGroup) === -1) {
            return false;
        }
        return true;
    }
    getPopularItemsTitle() {
        const activeFilters = this.getActiveFiltersWithoutReference();
        return activeFilters.length ? this.context.locParams('CuratedType_Most_Viewed_Title_In', [
            activeFilters[0].Title
        ], `Most viewed in ${[
            activeFilters[0].Title
        ]}`) : this.context.loc('CuratedType_Most_Viewed', 'Most Viewed');
    }
    shouldRenderBanner() {
        return this.props.isAppSource && !this.props.isEmbedded && !this.getCurrentEntityData().subsetSearchQuery && this.getCurrentEntityData().activeFilters.length === 0;
    }
    renderBannner() {
        return this.shouldRenderBanner() ? /*#__PURE__*/ _jsx(Banner, {
            data: this.getCurrentEntityData().bannerData
        }) : null;
    }
    isFullscreenEmbedded() {
        return embedHostUtils.shouldShowCuratedData(this.props.embedHost) && embedHostUtils.isFullScreenMode(this.props.query);
    }
    getRibbonItems() {
        return getFeaturedItemsByFilter(this.getCurrentEntityData().activeFilters, this.getCurrentEntityData().curatedData, this.getCurrentEntityData().idMap, this.getCurrentEntityData().allData).slice(0, 5);
    }
    getFilteredItems() {
        const ribbonItems = this.getRibbonItems();
        const filteredItems = removeDuplicateAddIns(this.getCurrentEntityData().allData, 'entityId').apps.filter((app)=>ribbonItems.every((ribbonItem)=>app.entityId !== ribbonItem.entityId));
        return filteredItems;
    }
    getPopularItems() {
        if (!this.isShowPopularItems()) {
            return [];
        }
        return getPopularItems({
            allItems: this.getFilteredItems(),
            featuredItems: this.getRibbonItems()
        });
    }
    renderPopularRibbon() {
        const popularItems = this.getPopularItems();
        return popularItems.length ? /*#__PURE__*/ _jsx(PopularApps, {
            popularAppsTitle: this.getPopularItemsTitle(),
            ribbonPopularApps: popularItems,
            ribbonKey: this.getRibbonKey()
        }) : null;
    }
    renderRecommendationsRibbons() {
        const { isAppSource, entityType, selectedLocale, countryCode, recoMicrosoft365WhatsNewItems, recoMicrosoft365TrendingItems, entityData, query, recoTrendingItems, recoWhatsNewItems } = this.props;
        const TileType = getEntityRegistration(entityType).tileType;
        const isOfficeFilter = (query === null || query === void 0 ? void 0 : query.product) === Constants.FilteredGallery.officeFilter;
        const hasNoActiveFilters = entityData[`${entityType}`].activeFilters.length === 0;
        const isFirstPage = !query.page || query.page === '1';
        const hasSearch = query === null || query === void 0 ? void 0 : query.search;
        return (isOfficeFilter && entityType === Constants.EntityType.App || hasNoActiveFilters && isFirstPage) && (entityType === Constants.EntityType.App || entityType === Constants.EntityType.Service) && isAppSource && !hasSearch && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(RecommendationsRibbon, {
                    recommendedItems: isOfficeFilter ? recoMicrosoft365TrendingItems : recoTrendingItems,
                    title: this.context.loc('CuratedType_Trending_Now', 'Trending Now'),
                    ribbonKey: Constants.Recommendations.TrendingMicrosoft365,
                    selectedCountry: countryCode,
                    selectedLocale: selectedLocale,
                    tileType: TileType
                }),
                /*#__PURE__*/ _jsx(RecommendationsRibbon, {
                    recommendedItems: isOfficeFilter ? recoMicrosoft365WhatsNewItems : recoWhatsNewItems,
                    title: this.context.loc('CuratedType_Whats_New', 'Whats New'),
                    ribbonKey: Constants.Recommendations.WhatsNewMicrosoft365,
                    selectedCountry: countryCode,
                    selectedLocale: selectedLocale,
                    tileType: TileType
                })
            ]
        });
    }
    renderCuratedGallery() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderBannner(),
                /*#__PURE__*/ _jsx("div", {
                    className: classNames({
                        curatedGalleryWrapper: this.getCurrentEntityData().activeFilters.length === 0 && !this.getCurrentEntityData().subsetSearchQuery
                    }),
                    children: /*#__PURE__*/ _jsx(CuratedGallery, {
                        entityType: this.props.entityType,
                        dataMap: this.getCurrentEntityData().dataMap,
                        category: this.props.params.category || this.props.query,
                        activeFilters: this.getCurrentEntityData().activeFilters,
                        searchText: this.getCurrentEntityData().subsetSearchQuery,
                        embedHost: this.props.embedHost
                    })
                })
            ]
        });
    }
    shouldRenderRibbonItems() {
        return this.getCurrentEntityData().showRibbon && !this.props.isEmbedded;
    }
    renderFeaturedRibbon() {
        var _this_getCurrentEntityData_activeFilters_, _this_getCurrentEntityData_activeFilters_1;
        const ribbonItems = this.getRibbonItems();
        const featuredRibbonKey = getFeaturedAppsTitle();
        const ribbonTitle = this.context.locParams(featuredRibbonKey, [
            (_this_getCurrentEntityData_activeFilters_ = this.getCurrentEntityData().activeFilters[0]) === null || _this_getCurrentEntityData_activeFilters_ === void 0 ? void 0 : _this_getCurrentEntityData_activeFilters_.Title
        ]);
        const ribbonKey = `${featuredRibbonKey} ${(_this_getCurrentEntityData_activeFilters_1 = this.getCurrentEntityData().activeFilters[0]) === null || _this_getCurrentEntityData_activeFilters_1 === void 0 ? void 0 : _this_getCurrentEntityData_activeFilters_1.BackendKey}`;
        return this.shouldRenderRibbonItems() && ribbonItems.length ? /*#__PURE__*/ _jsx("div", {
            className: "indFeaturedContainer",
            children: /*#__PURE__*/ _jsx(Ribbon, {
                title: ribbonTitle,
                children: ribbonItems.map((item, index)=>/*#__PURE__*/ _createElement(CommonTile, _object_spread_props(_object_spread({}, item), {
                        item: item,
                        tileIndex: index,
                        totalTiles: ribbonItems.length,
                        key: index,
                        ribbonKey: ribbonKey
                    })))
            })
        }) : null;
    }
    renderFilteredGallery() {
        const filteredItems = this.getFilteredItems();
        const { query, galleryPage, pageSize, embedHost, partnerAppDataLoaded, partnerAppDataLoadedError, entityType, isMobile, countryCode, changeSearchText, isEmbedded, selectedLocale, showPrivateApps, currentView, appsActiveFilters, servicesActiveFilters, cloudsIndustryActiveFilters, recoMicrosoft365WhatsNewItems, recoMicrosoft365TrendingItems } = this.props;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderBannner(),
                this.renderRecommendationsRibbons(),
                this.getCurrentEntityData().count ? /*#__PURE__*/ _jsx("div", {
                    className: "allResults",
                    children: this.context.loc('FilteredGallery_AllResults', 'All results')
                }) : null,
                /*#__PURE__*/ _jsx(AppSourceFilteredGallery, {
                    query: query,
                    galleryPage: galleryPage,
                    pageSize: pageSize,
                    filteredData: filteredItems,
                    count: this.getCurrentEntityData().count,
                    searchText: this.getCurrentEntityData().subsetSearchQuery,
                    showPrivateApps: showPrivateApps,
                    isEmbedded: isEmbedded,
                    embedHost: embedHost,
                    partnerAppDataLoaded: partnerAppDataLoaded,
                    partnerAppDataLoadedError: partnerAppDataLoadedError,
                    entityType: entityType,
                    isMobile: isMobile,
                    selectedLocale: selectedLocale,
                    selectedCountry: countryCode,
                    isSelectedFilters: isFilterChosen(currentView, appsActiveFilters, servicesActiveFilters, cloudsIndustryActiveFilters),
                    changeSearchText: changeSearchText,
                    microsoft365WhatsNewItems: recoMicrosoft365WhatsNewItems,
                    microsoft365TrendingItems: recoMicrosoft365TrendingItems
                })
            ]
        });
    }
    renderLoading() {
        return /*#__PURE__*/ _jsx("div", {
            className: "loading",
            children: /*#__PURE__*/ _jsx(Spinner, {
                label: this.context.loc('Gallery_Loading', 'Loading...'),
                ariaLive: "assertive",
                labelPosition: "left"
            })
        });
    }
    renderPromotionPane(bannerInfo) {
        return /*#__PURE__*/ _jsx(AppPromotionPane, {
            isEmbedded: this.props.isEmbedded,
            bannerInfo: bannerInfo
        });
    }
    renderHeader(asH1) {
        const { isAppSource, isEmbedded, entityType, entityData, currentView, query } = this.props;
        const shouldHideSortingDropdown = !this.isSearchMode(entityType, entityData);
        return isAppSource ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FilteredGalleryHeader, {
                    localizedTitle: this.getGalleryMainTitle(),
                    subTitle: this.getGallerySubTitle(),
                    otherGalleriesLinks: this.renderOthersGalleriesLinks(),
                    numResults: this.getCurrentEntityData().count,
                    hideSortingDropdown: shouldHideSortingDropdown,
                    titleAsH1: asH1
                }),
                /*#__PURE__*/ _jsx(GalleryHeader, {
                    activeFilters: this.getCurrentEntityData().activeFilters,
                    searchText: this.getCurrentEntityData().subsetSearchQuery,
                    getFilterLink: this.filterLinkCallback.bind(this),
                    isEmbedded: isEmbedded,
                    entityType: entityType,
                    currentView: currentView,
                    urlQuery: query
                })
            ]
        }) : null;
    }
    renderImpl() {
        const { showPrivateApps, isEmbedded, embedHost, entityType, stateCountryFilterHandler, countryCode, regionCode, params, query, currentView, requestFilteredLoading, entityData, isMaccUser } = this.props;
        if (!entityType) {
            return /*#__PURE__*/ _jsx("div", {});
        }
        const hideFilterPane = isEmbedded && (embedHostUtils.shouldHideFilterPane(embedHost) || showPrivateApps);
        const galleryContainerClass = classNames({
            spza_content: true,
            spza_content_hideFilterPane: hideFilterPane
        });
        const bannerInfo = getPromotionBanner({
            searchText: this.getCurrentEntityData().subsetSearchQuery,
            entityType,
            activeFilters: this.getCurrentEntityData().activeFilters
        });
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("div", {
                className: "spza_galleryContainer",
                role: "main",
                children: /*#__PURE__*/ _jsx("div", {
                    className: galleryContainerClass,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "paneAndGalleryWrapper",
                        children: [
                            hideFilterPane ? null : /*#__PURE__*/ _jsx(FilterPane, {
                                dataMap: this.getCurrentEntityData().dataMap,
                                activeFilters: this.getCurrentEntityData().activeFilters,
                                getFilterLink: this.filterLinkCallback.bind(this),
                                embedHost: embedHost,
                                isEmbedded: isEmbedded,
                                entityType: entityType,
                                stateCountryFilterHandler: stateCountryFilterHandler,
                                countryCode: countryCode.toUpperCase(),
                                regionCode: regionCode,
                                params: params,
                                query: query,
                                currentView: currentView,
                                countriesList: this.getCurrentEntityData().countriesList,
                                isMaccUser: isMaccUser
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "gallery",
                                // eslint-disable-next-line react/forbid-dom-props
                                id: "maincontent",
                                tabIndex: -1,
                                children: /*#__PURE__*/ _jsxs(GalleryContent, {
                                    loadingComponent: this.renderLoading(),
                                    requestFilteredLoading: requestFilteredLoading,
                                    children: [
                                        this.renderPromotionPane(bannerInfo),
                                        this.renderHeader(!bannerInfo),
                                        this.shouldShowCuratedView(entityType, entityData, query) ? this.renderCuratedGallery() : this.renderFilteredGallery()
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "context", void 0), _define_property(this, "getRibbonKey", ()=>{
            const activeFilters = this.getActiveFiltersWithoutReference();
            return activeFilters.length ? `CuratedType_Most_Viewed ${activeFilters[0].UrlKey}` : 'CuratedType_Most_Viewed';
        });
        this.state = {
            shouldDisplayNumricValues: false
        };
    }
}
Gallery.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
